import { render, staticRenderFns } from "./InsuranceCommissionList.vue?vue&type=template&id=2630401e&"
import script from "./InsuranceCommissionList.vue?vue&type=script&lang=ts&"
export * from "./InsuranceCommissionList.vue?vue&type=script&lang=ts&"
import style0 from "./InsuranceCommissionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports